/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Mijn PiE BFF
 * OpenAPI spec version: 1.0
 */

export type MarketParticipantType = typeof MarketParticipantType[keyof typeof MarketParticipantType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MarketParticipantType = {
  BSP: 'BSP',
  CSP: 'CSP',
  DDK: 'DDK',
  DDM: 'DDM',
  DDQ: 'DDQ',
  MDR: 'MDR',
  EDSN: 'EDSN',
  CTO: 'CTO',
  EZ: 'EZ',
  CDS: 'CDS',
  OSP: 'OSP',
} as const;
